import { Grid, Typography } from '@mui/material';

const PageNotFound = () => {
    return (
        <Grid
            container
            spacing={2}
            direction="column"
            alignItems="center"
            justifyContent="center"
            sx={{ minHeight: 'calc(100vh - 150px)' }}
        >
            <Grid item xs={12}>
                <Typography sx={{ fontSize: '80px', color: 'red' }}>Page Not Found!</Typography>
            </Grid>
        </Grid>
    );
};

export default PageNotFound;
